import { Input, Component, AfterViewInit, ElementRef, Output, OnInit, OnChanges, SimpleChanges, Renderer2, OnDestroy, ChangeDetectorRef, ViewChild, Host, Optional, HostListener } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

import * as go from "gojs";

import { WorkflowBuilderComponent } from "./workflow-builder.component";

import { BuilderService } from "../../services/builder.service";
import { DialogService } from "../../../common/services/dialog.service";
import { EventsService } from "../../../services/events.service";
import { FlowTemplateService } from "../../services/flow-template.service";
import { GoItemFactoryService } from "../../services/go-item-factory.service";
import { HeightWidthService } from "../../../common/services/height-width.service";
import { SidePanelService } from "../../../common/services/side-panel.service";
import { WorkOrderStatus } from "../../../common/models/work-order.model";
import { Button, ButtonKind, ButtonPosition, ChangeTargetRule, ContextConfig, FlowTemplate, Page, PageType, Question, QuestionKind, Rule, Section, SectionConfig, SideEffect, SideEffectType, State, StateType, SummaryControlConfig, Transition } from "../../../common/models/flow.dto";
import { deepClone, TransitionEditorEvent, TransitionEditorEventType } from "../../models/editor.model";
import { genId } from "../../../core/services/genId";
import { getDiagramAreaHW } from "../../../common/models/height-width.model";
import { NodeKind, StringLiteral } from "../../../common/models/rules.model";
import { SidePanel } from "../../../common/models/side-panel.model";

@Component({
    templateUrl: "./workflow-diagram.component.html",
    selector: "workflow-diagram",
    providers: [DialogService],
    standalone: false
})

export class WorkflowDiagramComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  @Input() public template: FlowTemplate = null;
  @Input() public moduleGroupId: string | null = null;
  @Input() public moduleId: string | null = null;

  @Output() public selectedStateTransition: Transition = { name: "", sideEffects: [], outgoingRules: new Array<ChangeTargetRule>() };
  @Output() public selectedState: State = { name: "", sections: [], transitions: [], stateType: StateType.Undefined };
  @Output() public formType: string = "";

  @ViewChild('diagram', { read: ElementRef, static: true }) public diagramElement: ElementRef;
  @ViewChild('palette', { read: ElementRef, static: true }) public paletteElement: ElementRef;

  public _hwSubscription: Subscription;
  public diagram: go.Diagram;
  public palette: go.Palette;
  yOffsetValue: number = 100;
  xOffsetValue: number = 150;
  mainHeight: number = 75;
  mainWidth: number = 200;
  editHeight: number = 75;
  editWidth: number = 200;
  diagramPadding: number = 0;
  public showLabels: boolean = true;
  subscription: Subscription;
  readonly labelRowLabel: string = "Please review all information for accuracy.";
  readonly labelRowReviewLabel: string = "<br /> The \"add comments\" links are displayed to the permit requstor, to add internal supervisor comments click the \"supervisor\" comments button above.";
  public endEditorSidePanel: SidePanel = new SidePanel({
    tabs: [{ title: "Endpoint Editor" }],
    sections: [{ componentName: 'WorkflowDiagramEndEditor', method: (event) => this.endEditorEventHandler(event), componentData: { selectedState: this.selectedState } }],
    visible: false
  });
  public formEditorSidePanel: SidePanel = new SidePanel({
    tabs: [{ title: "Form Editor" }],
    sections: [{ componentName: 'WorkflowDiagramFormEditor', method: (event) => this.formEditorEventHandler(event), componentData: { template: this.template, formType: this.formType, selectedState: this.selectedState } }],
    visible: false
  });
  public formTransitionEditorSidePanel: SidePanel = new SidePanel({
    tabs: [{ title: "Transition Editor" }],
      sections: [{ componentName: 'WorkflowTransitionEditor', method: (event) => this.transitionEditorEventHandler(event), componentData: { template: this.template, transition: this.selectedStateTransition } }],
    visible: false
  });

  set flowInstanceName(val: string) {
    this.template.name = val;
  }
  get flowInstanceName(): string {
    return this.template.name;
  }

  constructor(
    public route: ActivatedRoute,
    public goFactory: GoItemFactoryService,
    public readonly dialogService: DialogService,
    @Optional() @Host() public _workflowBuilder: WorkflowBuilderComponent,
    public el: ElementRef,
    public renderer: Renderer2,
    public heightWidthService: HeightWidthService,
    public sidePanelService: SidePanelService,
    public eventsService: EventsService,
    public builder: BuilderService
  ) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["template"]) {
      this.setEditedTemplate(this.template);
      if (this.diagram)
        this.diagram.model = go.Model.fromJson(this.template.model);
      this.syncTemplateModel();
    }
  }

	ngAfterViewInit() {
    // we can depend on this resolving instantly because
    // angular resolvers finish the observable before
    // the route is activated
    this.setEditedTemplate(this.route.snapshot.data.template);
    if (this.route.snapshot.params.moduleGroupId !== undefined && this.route.snapshot.params.moduleId !== undefined) {
      this.moduleGroupId = this.route.snapshot.params.moduleGroupId;
      this.moduleId = this.route.snapshot.params.moduleId;
    }
    if (this.template !== undefined && this.template !== null && this.template.states.length > 0) {
      this.selectedState = this.template.states.find(s => s.name === "Start"); // set selected state to Start node by default
    }
    //get gojs diagram changes
    this.subscription = this.goFactory.diagramChange$
      .subscribe(e => {
        let event = <any>e;
        let callingFunction: string = event.callingFunction;
        if (callingFunction && typeof (this[callingFunction] === "function")) {
          this[callingFunction](event);
        }
      });

    //Get h/w from parent containers
		//this._hwSubscription = this.heightWidthService.getHW().subscribe(hw => {
		//	debugger;
  //    this.setDiagramContainerSize(hw);
  //  });

    //create subscription for Delete keypress
    this.eventsService.create('diagram', document, 'keyup', (event: KeyboardEvent) => {
      //do we have a "delete" key event and a diagram selection?
      if (event.key === 'Delete' && this.diagram && this.diagram.selection.count > 0) {
        this.deleteSelectDiagramShapes();
      }
    });

    //create diagram & palette
    this.palette = this.goFactory.buildPalette(this.paletteElement.nativeElement);
    this.diagram = this.goFactory.buildDiagram(this.diagramElement.nativeElement);
    //when the tab switches we must resize to get the correct div size
    if (this._workflowBuilder)
      this._workflowBuilder.onResize();

    //add diagram events
    this.addDiagramEvents();

    //set diagram model
    if (this.template.model.Class !== undefined && this.template.model.class === undefined)
      this.template.model = this.remapModelProperties(this.template.model);

    this.diagram.model = go.Model.fromJson(JSON.stringify(this.template.model));
  }

  ngOnDestroy(): void {
    if (this._hwSubscription)
      this._hwSubscription.unsubscribe();
    if (this.eventsService)
      this.eventsService.remove('diagram');
  }

  public endEditorEventHandler(e: any): void {
    this.selectedStateEventHandler(e.data);
  }

  //to be called any time the underlying template needs to be changed outside of a routing calling
  public setEditedTemplate(selected: FlowTemplate): void {
    this.template = selected;
    this.selectedState = { name: "", sections: [], stateType: StateType.Undefined };
  }

  public remapModelProperties(model: any): any {
    const newModel: any = {};
    newModel.class = model.Class;
    newModel.linkFromPortIdProperty = model.LinkFromPortIdProperty;
    newModel.linkToPortIdProperty = model.LinkToPortIdProperty;
    newModel.nodeDataArray = this.mapNodeProperties(model.NodeDataArray);
    newModel.linkDataArray = this.mapLinkProperties(model.LinkDataArray);
    return newModel;
  }

  public mapNodeProperties(nodes: Array<any>): Array<any> {
    const newNodes = new Array<any>();
    for (let i = 0; i < nodes.length; i++) {
      const newNode: any = {};
      newNode.key = nodes[i].Key;
      newNode.category = nodes[i].Category;
      newNode.text = nodes[i].Text;
      newNode.loc = nodes[i].LOC;
      newNodes.push(newNode);
    }
    return newNodes;
  }

  public mapLinkProperties(links: Array<any>): Array<any> {
    const newLinks = new Array<any>();
    for (let i = 0; i < links.length; i++) {
      const newLink: any = {};
      newLink.key = links[i].Key;
      newLink.from = links[i].From;
      newLink.to = links[i].To;
      newLink.points = links[i].Points;
      newLinks.push(newLink);
    }
    return newLinks;
  }

  /* Diagram Events > */
  public addDiagramEvents(): void {
    //add change observables
    this.diagram.addDiagramListener("ObjectSingleClicked", (e: any) => {
      e.builderKey = this.getSelectedBuilderKey(this.diagram, e);
      this.shapeClick(e);
    });
    this.diagram.addDiagramListener("ChangedSelection", (e: any) => {
      e.builderKey = this.getSelectedBuilderKey(this.diagram, e);
      this.selectionChanged(e);
    });
    this.diagram.addDiagramListener("SelectionMoved", (e: any) => {
      e.builderKey = this.getSelectedBuilderKey(this.diagram, e);
      this.selectionMoved(e);
    });
    this.diagram.addDiagramListener("LinkDrawn", (e: any) => {
      e.builderKey = this.getSelectedBuilderKey(this.diagram, e);
      this.linkDrawn(e);
    });

    this.diagram.addDiagramListener("ObjectContextClicked", (e: any) => {
      e.builderKey = this.getSelectedBuilderKey(this.diagram, e);
      this.shapeClick(e);
    });
  }
  /**
   * Separate function to delete diagram selected items
   *  2/14/19 - Focus to hidden menu is stopping commandHandler.deleteSelection from being called
   *  Using EventService for delete key event
   */
  public deleteSelectDiagramShapes(): void {
    let shapeType: string = "";
    let isDeletable: boolean = true;
    //TODO: account for mulitple selections during a delete
    for (var it = this.diagram.selection.iterator; it.next();) {
      var part = it.value;
      if (part instanceof go.Node) {
        shapeType = "Form";
        isDeletable = part.deletable;
      }
      else if (part instanceof go.Link) {
        shapeType = "Transition";
        isDeletable = part.deletable;
      }
    }
    //isDeletable comes from settings in go-item-factory.service.ts
    if (isDeletable) {
      //prompt for delete
      this.dialogService.openDialog("yesNo", "Are you sure you want to delete this " + shapeType + "?<br>All " + shapeType + " data will be lost after the delete.", "confirmDelete");
    } else {
      //alert, "can't be deleted"
      this.dialogService.openDialog("ok", "This " + shapeType + " can not be deleted.", "cannotDelete");
    }
  }

  //user drawn link
  public linkDrawn(e: any): void {
    let link = <go.Link>e.subject;
  }

  //single click shape
  public shapeClick(e: any): void {
    if (e) {
      //proper event type
      let event: go.DiagramEvent = <go.DiagramEvent>e;
      //category as defined in go-item-factory.service
      let shapeCategory = event.subject.part.data.category;
      //handle by category & some shapes are selectable
      if (shapeCategory && event.subject.part.isSelected) {
        // set it as currently editing/selected
        this.setSelectedState(e.builderKey);
        this.syncTemplateModel();  //necessary to ensure template's model object is in correct format for saving
        //set form editor type
        this.formType = shapeCategory;
        //switch to handle different editing UI in right menu
        switch (shapeCategory) {
          case "decision":
            //do nothing - can't be selected to be moved in the diagram
            break;
          case "end":
            this.showEndEditor();
            this.selectedState.isTerminal = true;
            break;
          case "inputForm":
            //show form editor
            this.showFormEditor();
            break;
          case "review":
          case "redo":
            this.showTransitionEditor();
          case "link":
            //show transition editor
            this.sidePanelService.toggleSidePanel(false);
            //set transition selection
            this.handleSelectedLink(event);
            break;
          case "reviewForm":
            //show form editor
            this.showFormEditor();
            break;
          case "start":
            //show form editor
            this.showFormEditor();
            //initial property helps with button disabling in form editor
            this.selectedState.isInitial = true;
            break;
          case "unselectable":
            //do nothing - can't be selected to be moved in the diagram
            break;
          default:
            alert("missed case in workflow-diagram.component > shapeClick, add new shape Catgeory: " + shapeCategory);
        }
      } else {
        // set it as currently editing/selected
        this.setSelectedState(e.builderKey);
        this.syncTemplateModel();
        //set transition selection
        this.handleSelectedLink(event);
      }
    }
  }
  //after shape deleted, data cleanup
  public shapeDeleteDataSync(): void {
    //update template for gojs model
    this.syncTemplateModel();
    //delete extra transitions
    this.deleteExcessTransaction();
    //highlight node with no end point
    this.checkNodeConnectivity();
  }
  //select change
  public selectionChanged(e: any): void {
    //set it as currently editing/selected
    this.setSelectedState(e.builderKey);
  }
  //select moved
  public selectionMoved(e: any): void {
    //make sure template has the new nodeArray position for moved shape
    this.syncTemplateModel();
  }
  /* < Diagram Events */

  /* Diagram > */

  //set diagram container size
  public setDiagramContainerSize(hw: any): void {
    //set vars
    if (hw.mainHeight) this.mainHeight = hw.mainHeight;
    if (hw.mainWidth) this.mainWidth = hw.mainWidth;
    if (hw.diagramPadding) this.diagramPadding = hw.diagramPadding;
    if (hw.editHeight) this.editHeight = hw.editHeight;
    //are all set? (from 2 different components)
    if (this.mainHeight !== 0 && this.mainWidth !== 0 && this.editHeight !== 0 && this.diagramPadding !== 0) {
      //get new height
      let newHW = getDiagramAreaHW(this.mainHeight, this.mainWidth, this.editHeight, this.diagramPadding);
      //resize diagram container h/w
      this.setContainerSize('.gojs-diagram-container', newHW);
      //resize diagram div
      this.setContainerSize('#myDiagramDiv', newHW);
      //resize the diagram
      this.diagram.requestUpdate();
      //reset values back to 0 for next resize event
      this.resetHWValues();
    }
  }

  public setContainerSize(selector: string, hw: any): void {
    let container: HTMLElement = this.el.nativeElement.querySelector(selector);
    if (container) {
      this.renderer.setStyle(container, 'width', hw.width + "px");
      this.renderer.setStyle(container, 'height', hw.height + "px");
    }
  }

  //clears values to repeately trigger setDiagramContainerSize()
  public resetHWValues(): void {
    this.mainHeight = 0;
    this.mainWidth = 0;
    this.editHeight = 0;
    this.diagramPadding = 0;
  }

  public showEndEditor(): void {
    this.sidePanelService.newSidePanel(this.endEditorSidePanel);
    this.sidePanelService.updateSectionData('WorkflowDiagramEndEditor', { template: this.template, formType: this.formType, selectedState: this.selectedState, moduleGroupId: this.moduleGroupId, moduleId: this.moduleId })
    this.sidePanelService.toggleSidePanel(true);
  }

  public showFormEditor(): void {
    this.sidePanelService.newSidePanel(this.formEditorSidePanel);
    this.sidePanelService.updateSectionData('WorkflowDiagramFormEditor', { template: this.template, formType: this.formType, selectedState: this.selectedState, moduleGroupId: this.moduleGroupId, moduleId: this.moduleId })
    this.sidePanelService.toggleSidePanel(true);
  }

  public showTransitionEditor(): void {
    this.sidePanelService.newSidePanel(this.formTransitionEditorSidePanel);
    this.sidePanelService.updateSectionData('WorkflowTransitionEditor', { template: this.template, transition: this.selectedStateTransition });
    this.sidePanelService.toggleSidePanel(true);
  }

  //handle selected link
  public handleSelectedLink(event: go.DiagramEvent): void {
    if (event.subject.part.selectable) {
      // get link data
      let data = event.subject.part.data;
      //get transition (template) for link
      let selectedTransition = <Transition>this.getTransitionByLinkData(data);
      if (selectedTransition) {
        //clear selected State
        this.selectedState = { name: "", sections: [], stateType: StateType.Undefined };
        //set selected state editing transition
        this.selectedStateTransition = selectedTransition;
        this.sidePanelService.toggleSidePanel(false);
        this.showTransitionEditor();
      } else {
        alert("missed transition selection when clicking on a link");
      }
    }
  }
  //gets selected state builder key
  public getSelectedBuilderKey(result: go.Diagram, e: any): number {
    for (let it = result.selection.iterator; it.next();) {
      //add key from gojs model
      return it.value.data.key;
    }
  }
  //called from form editor add transition button click
  public selectedStateEventHandler(e: Event): void {
    //get model data for the selected shape
    let nodeModel = this.getNodeModelByKey(this.selectedState.key);
    //update shape name in gojs model
    if (nodeModel) {
      //shape name
      this.setDataProperty(nodeModel, "text", this.selectedState.name);
      //make sure the models stay in sync
      this.updateSelectedStateIncomingTransitionTargetStates();
    }
    this.syncTemplateModel();
  }

  //add button click events from form-editor
  public addEventHandler(addType: string, cloneForm: boolean = false): void {
    //get model data for the selected shape
      let nodeModel = this.getNodeModelByKey(this.selectedState.key);
      let moveTransition = this.selectedStateTransition != null && this.selectedStateTransition.name != null && this.selectedStateTransition.name.length > 0;
    if (nodeModel) {
        switch (addType) {
            case "inputForm":
            case "input":                
                this.handleSelectStateAdditions(nodeModel, StateType.InputForm, `Input Form_${this.getNodeCountByCategory("inputForm")}`, moveTransition, cloneForm);
                break;
            case "transition":
                this.handleSelectStateAdditions(nodeModel, StateType.InputForm, `Input Form_${this.getNodeCountByCategory("inputForm")}`);
                break;
            case "end":
                this.handleSelectStateAdditions(nodeModel, StateType.End, 'End');
                break;
            case "reviewForm":
            case "review":
                this.handleSelectStateAdditions(nodeModel, StateType.ReviewForm, `Review Form_${this.getNodeCountByCategory("reviewForm")}`, moveTransition, cloneForm);
                break;
            default:
                alert("Missed case in workflow-diagram.component > addEventHandler, check for new add event type :" + addType);
                break;
      }
    }
    //highlight node with no end point
    this.checkNodeConnectivity();
  }
  //add Goto link click event from form-editor
  public addGotoLinkEventHandler(linkData: any): void {
    //add diagram link & update template
    this.addJumpTransition(linkData);
    //make sure template model = gojs model
    this.syncTemplateModel();
    //highlight node with no end point
    this.checkNodeConnectivity();
    //after adding new links, should we had the new label?
    this.hideShowLinkLabels(this.showLabels);
  }

  public addTransitionHandler(transitionData: any): void {
    this.handleAddTransition(parseInt(transitionData.from, 10), parseInt(transitionData.to, 10));
  }

  public handleAddTransition(fromNode: any, toNode: any): void {
    const isReview = fromNode === toNode;
    const linkType = (isReview) ? "review" : "link";
    const link = this.getNewLink(fromNode, toNode, linkType);
    this.diagram.model.startTransaction("new link");
    (this.diagram.model as go.GraphLinksModel).addLinkData(link);
    this.diagram.model.commitTransaction("new link");
    const transition = this.getNewTransition(link);
    if (isReview) {
      transition.sideEffects.push(this.populateCompleteWorkItemEffect());
    }
    this.selectedState.transitions.push(transition);
    this.syncTemplateModel();
  }

  //creates new nodes & links based on transitions
  public handleSelectStateAdditions(nodeModel: any, shapeType: StateType, nodeText: string, moveTransition: boolean = false, cloneForm: boolean = false): void {
    //add diagram link & update template
    this.addTransition(nodeModel, shapeType, nodeText, moveTransition, cloneForm);
    //make sure template model = gojs model
    this.syncTemplateModel();
    //after adding new links, should we had the new label?
    this.hideShowLinkLabels(this.showLabels);
  }

  //adding jump transition from State
  public addJumpTransition(linkData: any): void {
    //Diagram Addition
    //start diagram transaction
    this.diagram.model.startTransaction("new link");
    //create new link data
    let newLinkData = this.getNewLink(<number>linkData.from, linkData.to, "redo");
    //create link from decision to toKey
    (this.diagram.model as go.GraphLinksModel).addLinkData(newLinkData);
    //end diagram transaction
    this.diagram.model.commitTransaction("new link");
    //Template Addition
    //add new Transition to selected State
    const transition = this.getNewTransition(newLinkData);
    if (this.selectedState.stateType === StateType.ReviewForm) {
      this.populateReturnButton(transition); //TODO: Button will need to be reworked to be new return type or something
      transition.sideEffects.push(this.populateReturnWorkItemEffect());
    }
    this.selectedState.transitions.push(transition);
  }

  //adding a transition under a State
    public addTransition(nodeModel: any, shapeType: StateType, nodeText: string, moveTransition: boolean = false, cloneForm: boolean = false): void {
    //get unique id
    let newNodeKey = this.getNextNodeKey();
    //get from node
    let fromNode = this.getNodeShapeByKey(nodeModel.key);

    //Diagram Additions
    //start diagram transaction
    this.diagram.model.startTransaction("new node & link");
    //get new node offset location
    let newNodeLocation = this.getNewNodeLocation(fromNode, shapeType);
    //add new input form shape

        let newNode = this.getNewNode(newNodeKey, nodeText, shapeType, newNodeLocation);
        this.diagram.model.addNodeData(newNode);
        if (moveTransition) {
            let transitionIndex = this.selectedState.transitions.findIndex(t => t.key == this.selectedStateTransition.key);
            if (transitionIndex != -1) { this.selectedState.transitions.splice(transitionIndex, 1); }          
            let replacementLink = this.getNewLink(newNode.key, this.selectedStateTransition.toStateKey, "link");
            replacementLink.text = this.selectedStateTransition.name;
            replacementLink.key = this.selectedStateTransition.key;
            (this.diagram.model as go.GraphLinksModel).addLinkData(replacementLink);
            let existingLink = (this.diagram.model as go.GraphLinksModel).linkDataArray.find(l => (l as any).from == this.selectedStateTransition.fromStateKey);
            if (existingLink != null) {
                (this.diagram.model as go.GraphLinksModel).removeLinkData(existingLink);
            }
            this.selectedStateTransition.fromStateKey = newNode.key;
        }

    //get new link data
    let newLinkData = this.getNewLink(this.selectedState.key, newNodeKey, "link");
    //add link betwen the original form and new input form
    (this.diagram.model as go.GraphLinksModel).addLinkData(newLinkData);
    //end diagram transaction
    this.diagram.model.commitTransaction("new node & link");

    //Template Additions
    //add new State to Template
        let newState = this.getNewState(nodeText, null, false, shapeType === StateType.End, newNodeKey, shapeType);
        if (cloneForm && this.selectedState != null) {
            newState.sections = [];
            for (let p = 0; p < this.selectedState.sections.length; p++) {
                newState.sections.push(deepClone(this.selectedState.sections[p]));
            }
        }
    if (this.selectedState.stateType !== StateType.Start && newState.stateType === StateType.ReviewForm) {
      newState = this.populateReviewForm(newState);
        }
        if (moveTransition) {
            newState.transitions.push(this.selectedStateTransition);
        }
    this.template.states.push(newState);

    //add new Transition to selected State
    const transition = this.getNewTransition(newLinkData);
    if (shapeType === StateType.End) {
      transition.sideEffects.push(this.populateCompleteWorkItemEffect());
    }
    this.selectedState.transitions.push(transition);
  }

  public populateCompleteWorkItemEffect(): SideEffect {
    return {
      id: genId(),
      label: "Complete Current Work Item",
      implementationType: SideEffectType.CompleteWorkItem,
      configuration: { targetStatus : WorkOrderStatus.Completed }
    } as SideEffect;
  }

  public populateReturnWorkItemEffect(): SideEffect {
    return {
      id: genId(),
      label: "Return Current WorkItem",
      implementationType: SideEffectType.ReturnWorkItem,
      configuration: {}
    } as SideEffect;
  }

  public populateReturnButton(targetTransition: Transition): void {
    const summaryPage = this.getPageByType(PageType.Summary);
    if (summaryPage) {
      const targetState = this.template.states.find(s => s.key === targetTransition.toStateKey);
      const goToLabel = `Go to ${targetState.name}`;
      let existingButton: Button = undefined;
      for (let i = 0; i < summaryPage.buttons.length; i++) {
        if (summaryPage.buttons[i].type === ButtonKind.Return) {
          const rule = summaryPage.buttons[i].targetTransitionRule;
          if (rule) {
            const stringRule = rule.parseTree as StringLiteral;
            if (stringRule.value === targetState.name) {
              existingButton = summaryPage.buttons[i];
            }
          }
        }
        if (existingButton !== undefined && existingButton !== null) break;
      }
      if (!existingButton) {
        const button = {
          id: genId(),
          position: ButtonPosition.Right,
          label: goToLabel,
          enabledRule: null,
          type: ButtonKind.Return,
          targetTransitionRule: this.getGoToRule(goToLabel, targetTransition.name),
          visibleRule: null,
          disableTypeChange: true
        } as Button;
        summaryPage.buttons.push(button);
      }
    }
    const commentPage = this.getPageByType(PageType.ReviewComments);
    if (commentPage !== undefined && commentPage !== null) {
      const targetState = this.template.states.find(s => s.key === targetTransition.toStateKey);
      const goToLabel = `Return`;
      let existingButton: Button = undefined;
      for (let i = 0; i < commentPage.buttons.length; i++) {
        if (commentPage.buttons[i].type === ButtonKind.Return) {
          const rule = commentPage.buttons[i].targetTransitionRule;
          if (rule) {
            const stringRule = rule.parseTree as StringLiteral;
            if (stringRule.value === targetState.name) {
              existingButton = summaryPage.buttons[i];
            }
          }
        }
        if (existingButton !== undefined && existingButton !== null) break;
      }
      if (!existingButton) {
        const button = {
          id: genId(),
          position: ButtonPosition.Right,
          label: goToLabel,
          enabledRule: null,
          type: ButtonKind.Return,
          targetTransitionRule: this.getGoToRule(goToLabel, targetTransition.name),
          visibleRule: null,
          disableTypeChange: true
        } as Button;
        commentPage.buttons.push(button);
      }
    }
  }

  public getPageByType(type: PageType): Page {
    let searchPage: Page = undefined;
    for (let s = 0; s < this.selectedState.sections.length; s++) {
      const section = this.selectedState.sections[s];
      searchPage = section.pages.find(pg => pg.pageType === type);
      if (searchPage) break;
    }
    return searchPage;
  }

  public getGoToRule(label: string, transitionName: string): Rule {
    return {
      ruleId: genId(),
      name: label,
      expression: `'${transitionName}'`,
      parseTree: { nodeType: NodeKind.StringLiteral, line: 1, column: 0, value: `'${transitionName}'` } as StringLiteral
    };
  }

  public populateReviewForm(reviewForm: State): State {
    if (this.selectedState.stateType == StateType.InputForm) return this.createReviewFormFromInputForm(reviewForm);
    if (this.selectedState.stateType == StateType.ReviewForm) return this.copyReviewForm(reviewForm);
    return reviewForm;
  }

  public copyReviewForm(reviewForm: State): State {
    const source = this.selectedState;
    reviewForm.sections = deepClone(source.sections);
    return reviewForm;
  }

  public createReviewFormFromInputForm(reviewForm: State): State {
    let summaryPage: Page;
    const inputSummary = this.getPageByType(PageType.Summary);
    let hasCommentRow: boolean = false;
    if (!inputSummary) {
      summaryPage = {
        pageNumber: 0,
        pageType: PageType.Summary,
        buttons: [],
        section: "",
        incomingRules: [],
        questions: [],
        subtitle: "Summary"
      } as Page;
      summaryPage.questions.push(this.generateLabel(reviewForm.stateType));
      summaryPage.questions.push(this.generateSummary());
    } else {
      summaryPage = deepClone(inputSummary);
      summaryPage.pageNumber = 0;
      summaryPage.buttons = new Array<Button>();
      for (let r = 0; r < summaryPage.questions.length; r++) {
        const row = summaryPage.questions[r];
        for (let q = 0; q < row.length; q++) {
          const question = row[q];
          if (question.type === QuestionKind.Summary) {
            question.config.isReviewForm = true;
          } else if (question.type === QuestionKind.ReviewComments) {
            hasCommentRow = true;
          } else if (question.type === QuestionKind.Label &&
            question.label === this.labelRowLabel) {
            question.label = `${question.label} ${this.labelRowReviewLabel}`;
          }
        }
      }
    }
    if (!hasCommentRow) {
      summaryPage.questions.push(this.builder.generateReviewComments());
    }
    summaryPage.buttons.push(this.addRightButton("Next", ButtonKind.Next, false));
    summaryPage.buttons.push(this.addRightButton("Approve", ButtonKind.Approve, true));
  //  summaryPage.buttons.push(this.addRightButton("Assign Additional Reviewer", ButtonKind.AddReviewer, true));
    let totalPages = 0;
    for (let s = 0; s < this.selectedState.sections.length; s++) {
      const section = {
        name: this.selectedState.sections[s].name,
        isRequired: this.selectedState.sections[s].isRequired,
        pages: [],
        id: this.selectedState.sections[s].id
      } as Section;
      if (s === 0) {
        section.pages.push(summaryPage);
        totalPages++;
      }
      for (let p = 0; p < this.selectedState.sections[s].pages.length; p++) {
        if (this.selectedState.sections[s].pages[p].pageType !== PageType.Summary) {
          const page = deepClone(this.selectedState.sections[s].pages[p]) as Page;
          page.section = section.id;
          if (s === 0 && this.selectedState.sections[s].pages.length <= 1) {
            const leftButton = {
              position: ButtonPosition.Left,
              label: "Back to Summary",
              type: ButtonKind.Back,
              disableTypeChange: false
            } as Button;
            page.buttons.push(leftButton);
          }
          totalPages++;
          section.pages.push(page);
        }
      }
      summaryPage.section = section.id;
      reviewForm.sections.push(section);
    }

    const commentPage = {
      pageNumber: totalPages,
      pageType: PageType.ReviewComments,
      subtitle: "Complete Review",
      questions: [],
      section: "",
      buttons: [
        { position: ButtonPosition.Left, label: "Back", type: ButtonKind.Back, disableTypeChange: false } as Button
      ],
      incomingRules: []
    } as Page;
    commentPage.questions.push(this.builder.generateReviewComments());
   // commentPage.buttons.push(this.addRightButton("Assign Additional Reviewer", ButtonKind.AddReviewer, true));
    commentPage.buttons.push(this.addRightButton("Approve", ButtonKind.Approve, true));

    const lastSection = reviewForm.sections[reviewForm.sections.length - 1];
    if (lastSection) {
      commentPage.section = lastSection.id;
      lastSection.pages.push(commentPage);
    }

    return reviewForm;
  }

  public addRightButton(buttonLabel: string, type: ButtonKind, disableTypeChange: boolean): Button {
    return {
      id: genId(),
      position: ButtonPosition.Right,
      label: buttonLabel,
      type: type,
      visibleRule: null,
      enabledRule: null,
      targetPageRule: null,
      targetTransitionRule: null,
      disableTypeChange: disableTypeChange
    } as Button;
  }

  public generateLabel(stateType: StateType): Array<Question> {
    const labelRow = new Array<Question>();
    const labelQuestion = {
      key: genId(),
      label: this.labelRowLabel,
      type: QuestionKind.Label,
      defaultValue: "",
      //"files": [],
      validationRules: [],
      changeRules: [],
      notes: []
    } as Question;
    if (stateType === StateType.ReviewForm) {
      labelQuestion.label = `${labelQuestion.label} ${this.labelRowReviewLabel}`;
    }
    labelRow.push(labelQuestion);
    return labelRow;
  }

  public generateSummary(): Array<Question> {
    const summaryRow = new Array<Question>();
    const summary = {
      key: genId(),
      label: "Form Summary",
      config: {
        isReviewForm: true,
        sections: new Array<Section>(),
        contextValues: new Array<ContextConfig>(),
        configurations: new Array<SectionConfig>()
      } as SummaryControlConfig,
      type: QuestionKind.Summary,
      defaultValue: "",
      //"files": [],
      validationRules: [],
      changeRules: [],
      notes: []
    } as Question;
    summaryRow.push(summary);
    return summaryRow;
  }

  public getNewNodeLocation(fromNode: go.Node, shapeType: StateType): string {
    //multiplier based on number of nodes
    let xMulti = this.yOffsetValue * this.getOutogingNonJumpLinks(fromNode);
    //offset west
    let newNodeLocX = Math.round(fromNode.location.x) + xMulti;
    let newNodeLocY = Math.round(fromNode.location.y) + this.yOffsetValue;
    if (shapeType === StateType.ReviewForm) {
      newNodeLocX = newNodeLocX + this.xOffsetValue;
      newNodeLocY = newNodeLocY + (this.yOffsetValue * 1.25);
    }
    //offset south
    return newNodeLocX + " " + newNodeLocY;
  }

  //links out of
  public getOutogingNonJumpLinks(node: go.Node): number {
    let nonJumpLinksCount = 0;
    let linksOutOf = node.findLinksOutOf();
    while (linksOutOf.next()) {
      let link = linksOutOf.value;
      if (link.category === "link") continue;
      nonJumpLinksCount += 1;
    }
    return nonJumpLinksCount;
  }

  //targetStates updating
  public updateSelectedStateIncomingTransitionTargetStates(): void {
    for (let i = 0; i < (this.diagram.model as go.GraphLinksModel).linkDataArray.length; i++) {
      //get link model data
      let linkData: any = (this.diagram.model as go.GraphLinksModel).linkDataArray[i];
      //is link going into the selected state?
      if (linkData.to == this.selectedState.key) {
        //get transition
        let trns = this.getTransitionByKey(linkData.key);
        //set new targetState
        trns.targetState = this.selectedState.name;
      }
    }
  }

  //outgoing link count from given node
  public getOutgoingLinkCountByNode(node: go.Node): number {
    let count: number = 0;
    //loop all links in diagram
    for (let i = 0; i < (this.diagram.model as go.GraphLinksModel).linkDataArray.length; i++) {
      //get link model data
      let linkData: any = (this.diagram.model as go.GraphLinksModel).linkDataArray[i];
      //is this link associated with the selectedState?
      if (linkData.from === this.selectedState.key) {
        count += 1;
        //get node it's linked to
        let toNode: go.Node = this.getNodeShapeByKey(linkData.to);
        //is it connected to a decision shape?
        if (toNode.category === "decision") {
          //get decision outgoing links
          let allLinks = toNode.findLinksOutOf();
          //Loop over decision links
          while (allLinks.next()) {
            count += 1;
          }
        }
      }
    }
    return count;
  }

  //does the selected node already have a decision linked?
  public selectedNodeHasDecisionLink(): boolean {
    let selectedNode: go.Node = this.getNodeShapeByKey(this.selectedState.key);
    let it = selectedNode.linksConnected.iterator;
    while (it.next()) {
      let link = <go.Link>it.value;
      if (link.toNode.category === "decision") {
        return true;
      }

    }
    return false;
  }
  //get the decision node for selected node
  public getSelectedNodeDecisionLink(): go.Node {
    let selectedNode: go.Node = this.getNodeShapeByKey(this.selectedState.key);
    let it = selectedNode.linksConnected.iterator;
    while (it.next()) {
      let link = <go.Link>it.value;
      if (link.toNode.category === "decision") {
        return link.toNode;
      }
    }
  }
  //link constructor
    public getNewLink(fromKey: number, toKey: number, category: string): any {
    const fromNode = this.getNodeShapeByKey(fromKey);
    const fromText = fromNode.data.text;
    const toNode = this.getNodeShapeByKey(toKey);
    let text = `${fromText} - ${toNode.data.text}`;

    if (fromKey === toKey) {
      const existing = this.template.model.linkDataArray;
      let reviews = 0;
      for (let i = 0; i < existing.length; i++) {
        if (existing[i].to === existing[i].from && existing[i].from === fromKey) {
          reviews = reviews + 1;
        }
      }
      text = `Review_${reviews}`;
    } else {
      const existing = this.template.model.linkDataArray;
      let links = 0;
      for (let i = 0; i < existing.length; i++) {
        if (existing[i].to === toKey && existing[i].from === fromKey) {
          links = links + 1;
        }
      }
      text = `${text}_${links}`;
    }

    return {
      from: fromKey,
      to: toKey,
      key: genId(),
      category: category,
      dash: [3, 2],
      //"text": "From_" + fromText + "_To_" + toNode.data.text
      text: text,
    }
  }
  //node constructor
  public getNewNode(incrementedKey: number, newText: string, category: string, nodeLoc: any): any {
    return {
      "key": incrementedKey,
      "text": newText,
      "category": category,
      "loc": nodeLoc
    }
  }
  //returns node count by category
  public getNodeCountByCategory(category: string): number {
    let count = 1;
    //loop nodes in diagram
    for (let i = 0; i < this.diagram.model.nodeDataArray.length; i++) {
      let nd = <go.Node>this.diagram.model.nodeDataArray[i];
      if (nd.category == category) {
        count += 1
      }
    }
    return count;
  }

  //helper for location strings
  public getStringLocation(location: go.Point): string {
    return location.x + " " + location.y;
  }
  //clicked close in form editor
  public closeFormEditorHandler($event: any): void {
    this.sidePanelService.toggleSidePanel(false);
  }
  //clicked close in transition editor
  public closeTransitionEditorHandler($event: any): void {
    this.sidePanelService.toggleSidePanel(false);
  }

  //handler for different events in form editor
  public formEditorEventHandler(event: any): void {
    if (event.method == "changeEvent") {
      this.selectedStateEventHandler(event.data);
    }
    if (event.method == "addGotoEvent") {
      this.addGotoLinkEventHandler(event.data);
    }
    if (event.method == "addEvent") {
      this.addEventHandler(event.data, event.cloneForm);
    }
    if (event.method == "addTransitionEvent") {
      this.addTransitionHandler(event.data);
    }
  }

  //update link names (coming in from transition editor)
    public transitionEditorEventHandler(event: TransitionEditorEvent): void {

        switch (event.eventType) {
            case TransitionEditorEventType.NameChanged:
                var newName = event.transitionName;
                //set save data
                this.selectedStateTransition.name = newName;
                //get selected link
                let selected = this.diagram.selection.first();
                //get its part
                let part = selected.part;
                //is it a link?
                if (part instanceof go.Link) {
                    //set it's name to what's sent in from the transition editor
                    this.setDataProperty(part.data, "text", newName);
                } else {
                    alert("missed link selection in workflow-diagram.component > transitionNameEventHandler.")
                }
                //make sure new name is updated in the template links
                this.updateSelectedStateIncomingTransitionTargetStates();
                break;
            case TransitionEditorEventType.FormInserted:
                this.selectedState = this.template.states.find(s => s.transitions.find(t => t.key == this.selectedStateTransition.key));
                this.sidePanelService.toggleSidePanel(false);
                this.formEditorEventHandler({ method: "addEvent", data: event.formType, cloneForm: event.cloneForm });
                //will need to do something to move the transition to the new form, and determine if the form shoudl be cloned, but one step at a time
                break;
            default:
                alert('unsupported event type');
                break;
        }

        
    }


  //set selected state based on gojs events
  public setSelectedState(builderKey: number): void {
    if (this.getStateByKey(builderKey)) {
      //set state
      this.selectedState = this.getStateByKey(builderKey);
      //clear selected transition
      this.selectedStateTransition = <Transition>{ sideEffects: [], outgoingRules: [] };
    } else {
      //close editors
      this.sidePanelService.toggleSidePanel(false);
      //reset selected State
      this.selectedState = { name: "", sections: [], transitions: [], stateType: StateType.Undefined };
      //reset selected Transition
      this.selectedStateTransition = { name: "", sideEffects: [], outgoingRules: [] };
    }
  }
  //highlights node that don't have an end point associated with them
  public checkNodeConnectivity(): void {
    //loop nodes in diagram
    for (let i = 0; i < this.diagram.model.nodeDataArray.length; i++) {
      //get node
      let nd: go.Node = this.diagram.findNodeForData(this.diagram.model.nodeDataArray[i]);
      //is it 'Input' or 'Review' form?
      if (nd.category === StateType.InputForm || nd.category === StateType.ReviewForm) {
        //get vertical panel of node
        let grphObj = nd.findObject("container");
        //switch error highlight on/off
        if (nd.findNodesOutOf().count === 0) {
          grphObj.background = "#d89078";
        } else {
          grphObj.background = "transparent";
        }
      }
    }
  }
  //turns on/off link labels
  public hideShowLinkLabels(e: boolean): void {
    for (let i = 0; i < (this.diagram.model as go.GraphLinksModel).linkDataArray.length; i++) {
      //get data
      let linkData: any = (this.diagram.model as go.GraphLinksModel).linkDataArray[i];
      //get link shape
      let link = this.diagram.findLinkForData(linkData);
      //get link label
      let label = link.findObject("LABEL");
      if (label) {
        //hide/show link label
        label.visible = e;
      }
    }
  }
  /* < Diagram  */

  /* Diagram data helpers > */
  //node - model data
  public getNodeModelByKey(key: number): any {
    return this.diagram.model.findNodeDataForKey(key);
  }
  //node - shape
  public getNodeShapeByKey(key: number): go.Node {
    return this.diagram.findNodeForKey(key);
  }
  //link - shape
  public getLinkShapeByData(data: object): go.Link {
    return this.diagram.findLinkForData(data);
  }
  //single function to change model data values
  public setDataProperty(data: any, dataPropertyKey: any, value: any): void {
    //start transaction
    this.diagram.model.startTransaction("model update");
    //update gojs model
    this.diagram.model.setDataProperty(data, dataPropertyKey, value);
    //end transaction
    this.diagram.model.commitTransaction("model update");
    //update template model to match diagram (supports save)
    this.syncTemplateModel();
  }
  //main function to move model data from diagram to template (for saving)
  public syncTemplateModel(): void {
    if (this.diagram !== null && this.diagram !== undefined && this.diagram.model !== undefined && this.diagram.model !== null) {
        this.template.model = JSON.parse(this.diagram.model.toJson());
      let removedStates = [];
      this.template.states.forEach((x) => {
        let node = this.diagram.model.nodeDataArray.find((y: any) => y.key === x.key);
        if (!node)
          removedStates.push(x);
      });
      removedStates.forEach(x => this.removeState(x));
      }
  }
  //syncs selectedState links to GOJS diagram links

  //removes transitions if link is deleted in the diagram
  public deleteExcessTransaction(): void {
    //loop all selectedState transitions - remove any extras
    const excessTransitions = new Array<Transition>();
    for (let s = 0; s < this.template.states.length; s++) {
      const st: State = this.template.states[s];
      for (let t = 0; t < st.transitions.length; t++) {
        const trans: Transition = st.transitions[t];
        const match = this.getLinkByTransaction(trans);
        if (!match) {
          excessTransitions.push(trans);
          st.transitions.splice(t, 1);
        }
      }
      for (let sct = 0; sct < st.sections.length; sct++) {
        for (let p = 0; p < st.sections[sct].pages.length; p++) {
          const pg: Page = st.sections[sct].pages[p];
          for (let b = 0; b < pg.buttons.length; b++) {
            const btn = pg.buttons[b];
            if (btn.type === ButtonKind.Return) {
              const transDeleted = excessTransitions.filter(tr => tr.name === (btn.targetTransitionRule.parseTree as StringLiteral).value);
              if (transDeleted && transDeleted.length > 0) {
                pg.buttons.splice(b, 1);
              }
            }
          }
        }
      }
    }
  }

  public removeState(state: State): void {
    let index = this.template.states.findIndex(x => x === state);
    this.template.states.splice(index, 1);
    type K = keyof Transition;
    for (let transition of state.transitions) {
      let property: K = transition.fromStateKey === state.key ? 'toStateKey' : 'fromStateKey';
      let transitionState: State = this.template.states.find(y => y.key === transition[property]);
      if (!transitionState)
        continue;
      let transitionIndex = transitionState.transitions.findIndex(y => y.key === transition.key);
      transitionState.transitions.splice(transitionIndex, 1);
    }
  }
  //is there a linkDataArray match for the given transaction?
  public getLinkByTransaction(transaction: Transition): any {
    for (let i = 0; i < (this.diagram.model as go.GraphLinksModel).linkDataArray.length; i++) {
      //get link model data
      let linkData: any = (this.diagram.model as go.GraphLinksModel).linkDataArray[i];
      if (linkData.from == transaction.fromStateKey && linkData.to == transaction.toStateKey) {
        return linkData;
      }
    }
    return null;
  }
  //make sure node keys are unique and increasing
  public getNextNodeKey(): number {
    let nextValue = 0;
    for (let i = 0; i < this.diagram.model.nodeDataArray.length; i++) {
      let node = <go.Node>this.diagram.model.nodeDataArray[i];
      nextValue = Math.min(nextValue, <number>node.key);
    }
    return nextValue - 1;
  }
  /* < Diagram data helpers */

  /* States helpers > */
  //new state
  public getNewState(name: string = "", title: string = "", isInitial: boolean = false, isTerminal: boolean = false, key: number, stateType: StateType): State {
    let newState: State = {
      name: name,
      title: title,
      isInitial: isInitial,
      isTerminal: isTerminal,
      transitions: [],
      stateType: stateType,
      sections: [],
      key: key,
    };
    return newState;
  }
  //get state by key
  public getStateByKey(key: number): any {
    for (let i = 0; i < this.template.states.length; i++) {
      let theState: State = this.template.states[i];
      if (theState.key === key) {
        return theState;
      }
    }
  }
  /* < States helpers */

  /* Transition helpers > */
  //gets template transition from given diagram link data
    public getTransitionByLinkData(data: any): Transition {
    for (let i = 0; i < this.template.states.length; i++) {
      let state = <State>this.template.states[i];
      for (let j = 0; j < state.transitions.length; j++) {
        let trnstn = <Transition>state.transitions[j];
        if (trnstn.key === data.key) {
          //has it already had side effects added?
          if (!trnstn.sideEffects) {
            //add empty array for adding side effects
            trnstn.sideEffects = [];
          }
          return trnstn;
        }
      }
    }
  }

  public getNewTransition(linkData: any): Transition {
    let toNode = this.getNodeShapeByKey(<number>linkData.to);
    let targetName = toNode.data.text;
    return {
      name: linkData.text,
      fromStateKey: parseInt(linkData.from, 10),
      toStateKey: parseInt(linkData.to, 10),
      key: linkData.key,
      sideEffects: [],
      outgoingRules: [],
      targetState: targetName,
    } as Transition;
  }

  public getTransitionByKey(key: string): Transition {
    for (let s = 0; s < this.template.states.length; s++) {
      let st = this.template.states[s];
      for (let t = 0; t < st.transitions.length; t++) {
        let trns = st.transitions[t];
        if (trns.key == key) {
          return trns;
        }
      }
    }
  }
  /* < Transition helpers */

    public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    if (this.dialogService.dialogId === 'confirmDelete') {
      var cmd = this.diagram.commandHandler;
      // call base method
      go.CommandHandler.prototype.deleteSelection.call(cmd);
      //sync data
      this.shapeDeleteDataSync();
    }
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
  }

}
